import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./popup.css";

const Popup = (props) => {
  return (
    <Dialog
      open={true}
      onClose={props.handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: { position: "relative" },
      }}
      sx={{ ...(props.zIndex && { zIndex: props.zIndex }) }}
    >
      {!props.noClose && (
        <IconButton
          aria-label="close"
          onClick={props.handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
      <DialogContent sx={{ mt: props.noClose ? 0 : 3 }}>
        {props.title && <DialogTitle>{props.title}</DialogTitle>}
        {props.content}
      </DialogContent>
    </Dialog>
  );
};

export default Popup;